/**
 * @generated SignedSource<<f804e0b7443687c3ffc3e5232ec5712a>>
 * @relayHash cc07dc4570c5f23dcae6dba3e01bc64f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884

import type { ConcreteRequest } from 'relay-runtime';
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type useRealtimeAccessRequestsFlagsQuery$variables = {
  cloudId: string;
  contentId: string;
  duration?: number | null | undefined;
  limit?: number | null | undefined;
  start?: string | null | undefined;
};
export type useRealtimeAccessRequestsFlagsQuery$data = {
  readonly confluence_getLatestPendingRequests: {
    readonly latestPendingRequest: ReadonlyArray<{
      readonly creationDateTimestamp: AGG$Long | null | undefined;
      readonly creatorAaid: string | null | undefined;
      readonly id: string;
      readonly requestAccessType: ResourceAccessType;
      readonly user: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useRealtimeAccessRequestsFlagsQuery = {
  response: useRealtimeAccessRequestsFlagsQuery$data;
  variables: useRealtimeAccessRequestsFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": 5,
    "kind": "LocalArgument",
    "name": "duration"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "duration"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "start",
        "variableName": "start"
      }
    ],
    "concreteType": "ConfluenceLatestPendingRequests",
    "kind": "LinkedField",
    "name": "confluence_getLatestPendingRequests",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceContentAccessRequest",
        "kind": "LinkedField",
        "name": "latestPendingRequest",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "requestAccessType"
          },
          {
            "kind": "ScalarField",
            "name": "creatorAaid"
          },
          {
            "kind": "ScalarField",
            "name": "creationDateTimestamp"
          },
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRealtimeAccessRequestsFlagsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRealtimeAccessRequestsFlagsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cc07dc4570c5f23dcae6dba3e01bc64f",
    "id": "869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884",
    "metadata": {},
    "name": "useRealtimeAccessRequestsFlagsQuery",
    "operationKind": "query",
    "text": "query useRealtimeAccessRequestsFlagsQuery($cloudId:ID!,$contentId:ID!,$duration:Int=5,$limit:Int=10,$start:String){confluence_getLatestPendingRequests(cloudId:$cloudId,contentId:$contentId,duration:$duration,limit:$limit,start:$start){latestPendingRequest{id,requestAccessType,creatorAaid,creationDateTimestamp,user{id,displayName,photos{isPrimary,value}}}}}"
  }
};
})();

(node as any).hash = "b94cab17722d3b349c6aeac7cfa04a8f";

export default node;
